import AddModel from './Containers/add-model';

export default [
  {
    path: '/models/add/:projectId/:isNew',
    component: AddModel,
    private: true
  }
];



// WEBPACK FOOTER //
// ./src/Model/routes.js